// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {routerActions} from 'react-router-redux';

export const additionalRepair = claim =>
    dispatch => {

        dispatch({
            data: claim,
            type: actions.ADD_CLAIM_NORMAL_ADDITIONAL_REPAIR
        });

        dispatch(routerActions.push('/claims/normal/new/'));

    };



// WEBPACK FOOTER //
// ./src/claim/normal/action-creators/additional-repair.js